import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ElectricPhase } from '../../../../shared/modules/evc-api/models/constants';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { swiperDefaultConfig } from '@app/shared/directives/swiper.directive';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-electric-phase',
  providers: [createProvider(ElectricPhaseComponent)],
  templateUrl: './electric-phase.component.html',
  styleUrls: ['./electric-phase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectricPhaseComponent extends Step implements OnInit {
  readonly electricPhase = ElectricPhase;
  readonly formName = 'evcSimulator';
  readonly stepName: string = 'electric-phase';

  readonly slideConfig: { src: string; title: string; description: string }[] = [
    {
      src: './assets/evc/img/single-phase.png',
      title: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.singlePhase.title',
      description: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.singlePhase.description'
    },
    {
      src: './assets/evc/img/three-phase.png',
      title: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhase.title',
      description: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhase.description'
    },
    {
      src: './assets/evc/img/three-phase-neutral.png',
      title: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhaseNeutral.title',
      description: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhaseNeutral.description'
    }, {
      src: './assets/evc/img/cables-not-visible.png',
      title: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.notVisible.title',
      description: 'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.notVisible.description'
    },
  ];

  swiperConfig: SwiperOptions = {
    ...swiperDefaultConfig,
    slidesPerView: 1.5,
    spaceBetween: 20,
    centeredSlides: true,
    breakpoints: {}
  };

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  setDefaultValue() {
    this.control.get('electricPhase').patchValue(ElectricPhase.singlePhase);
  }

  writeValue(value) {
    super.writeValue({ electricPhase: value });
  }

  protected valueChanges(values) {
    super.valueChanges(values.electricPhase);
  }

  protected buildForm() {
    this.control = this.fb.group({
      electricPhase: this.fb.control('', [Validators.required]),
    });
    this.subscribeToValueChanges();
  }
}
